import { getAllOrdersRequest, getOneOrderRequest } from "../requests/index";
import store from "../store";

class OrderService {
  constructor(store, limit = 50) {
    this.page = 0;
    this.store = store;
    this.limit = limit;
  }

  async getOrder(orderno) {
    let order = await getOneOrderRequest(this.store.state.token, orderno);
    return order.data[0];
  }

  async loadNextOrderPage() {
    this.page++;
    await this.getPage();
  }

  async loadPreviousOrderPage() {
    this.page = this.page > 0 ? this.page - 1 : 0;
    await this.getPage();
  }

  async getPage() {
    try {
      let orders = (await getAllOrdersRequest(this.store.state.token, this.limit, this.page)).data;
      this.store.commit("setOrders", orders);
    } catch (e) {
      console.log("problem getting orders..", e);
    }
  }
}

export default {
  install(Vue, options) {
    Vue.prototype.$orderService = new OrderService(store, options.limit);
  }
};
